import { Component, ViewContainerRef } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MenuBarComponent } from './shared/menu-bar/menu-bar.component';
import { PrimeNGConfig } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { LoginService } from './auth/login.service';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MenuBarComponent,
    CommonModule,
    HttpClientModule,
    ToastModule
  ],
  providers: [HttpClient, Router, LoginService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'rorender-frontend';

  constructor(
    private primengConfig: PrimeNGConfig,
    private routes: Router,
    private loginService: LoginService,
    public viewContainerRef: ViewContainerRef
  ) {
    this.primengConfig.ripple = true;
    loginService.ngOnInit()
  }
}
